import { SxProps } from '@mui/material';

export const DpFanCardActionFrameSx: SxProps = {
	backgroundColor: '#F1F1F1',
	borderRadius: '4px',
	padding: '18px 17px',
	display: 'flex',
	flexDirection: 'column',
	gap: '5px',
};

export const DpFanCardActionTitleSx: SxProps = {
	color: '#2C2C2C',
	fontSize: '17px',
	fontWeight: '800',

	display: 'flex',
	alignItems: 'center',
	gap: '8px',
};

export const DpFanCardActionDescriptionSx: SxProps = {
	color: '#2C2C2C',
	fontSize: '15px',
};

export const DpFanCardActionButtonSx: SxProps = {
	fontSize: '15px',
	verticalAlign: 'baseline',
	marginLeft: '4px',
};
